// Community login url
export const TALAVVYCOMMUNITY = process.env.REACT_APP_TALAVVY_COMMUNITY_URL;

// variable for the backen endpoint ip address
export const API = process.env.REACT_APP_TALAVVY_HOME_API;
